/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment-timezone';
import { EXERCISE_TYPE } from '../../../../../shared/constants';
import { saveCalendarExercise, saveNonDateBasedWorkoutExercise } from '../../../ducks/calendarActions';
/**
 * file for updating create exercise form validation and initial values and values to be submited
 based on type.
 */

const useCalendarAutoSaveCalendarItems = () => {
  const dispatch = useDispatch();
  const [isAdding, setIsAdding] = useState(false);
  const viewType = useSelector((state) => state.calendar.data.viewType);
  const selectedDate = useSelector((state) => state.calendar.data.selectedDate);
  const selectedProgramDayNumber = useSelector((state) => state.calendar.data.selectedProgramDayNumber);
  const weekViewHorizontallyExpandedDay = useSelector(
    (state) => state.calendar.data.weekViewExpandedDay,
  );
  const currentUser = useSelector((state) => state.auth.data.currentUser);
  const calendarItems = useSelector((state) => state.calendar.data.calendarItems);
  const nonDateBasedProgramItems = useSelector((state) => state.calendar.data.nonDateBasedProgramItems);
  const programType = useSelector((state) => state.calendar.data.programType);
  const endpointFormattedDate = moment(selectedDate).format('YYYY-MM-DD');

  const effectiveSelectedProgramDayNumber = viewType === 'weekView' ? weekViewHorizontallyExpandedDay : selectedProgramDayNumber;
  const effectiveSelectedDate = weekViewHorizontallyExpandedDay && viewType === 'weekView' ? moment(weekViewHorizontallyExpandedDay).format('YYYY-MM-DD') : endpointFormattedDate;

  const errorAddReset = () => {
    setIsAdding(false);
  };

  const getExerciseType = (itemToSave) => {
    if (itemToSave.type === EXERCISE_TYPE.Questionnaire) {
      return 'questionnaire';
    }
    if (itemToSave.type === EXERCISE_TYPE.WarmUp) {
      return 'warm_up';
    }
    if (itemToSave.type === EXERCISE_TYPE.Cooldown) {
      return 'cooldown';
    }
    if (itemToSave.type === EXERCISE_TYPE.Health) {
      return 'health';
    }
    if (itemToSave.type === EXERCISE_TYPE.Note) {
      return 'note';
    }
    if (itemToSave.type === EXERCISE_TYPE.Progression) {
      return 'progression';
    }
    if (itemToSave.type === EXERCISE_TYPE.Lift) {
      return 'lift';
    }
    if (itemToSave === EXERCISE_TYPE.SAQC) {
      return 'saq+c';
    }
    if (itemToSave === EXERCISE_TYPE.Circuit) {
      return 'circuit';
    }
    return '';
  };

  const handleAutoSaveCalendarItem = (
    itemToSave,
    setSubmitting = () => {},
    closeModal = () => {},
    contentIndexParam = null,
    submissionObjectToSave = null,
    formattedDateToSave = null,

  ) => {
    let submissionObject;
    setIsAdding(true);
    const setSubmissionArray = [];
    const defaultSubmissionObject = {
      /** Conditional key based on programType: "date" OR "dayNumber" */
      [programType === 'free-form-program' ? 'dayNumber' : 'date']:
          programType === 'free-form-program'
            ? effectiveSelectedProgramDayNumber
            : effectiveSelectedDate,
      exerciseId: parseInt(itemToSave.id, 10),
      type: getExerciseType(itemToSave),
      sets: setSubmissionArray,
      showSessionBreakItems: false,
    };
    if (itemToSave.description) {
      defaultSubmissionObject.description = itemToSave.description;
    }
    if (submissionObjectToSave) {
      submissionObject = submissionObjectToSave;
    } else {
      submissionObject = defaultSubmissionObject;
    }

    /** if there is a passed content index param use that, else add to end of list */
    const newCalendarItemIndex = contentIndexParam || calendarItems[effectiveSelectedDate]?.exercises?.length; /** length will be the index we want to give to the added item */
    const newProgramItemIndex = contentIndexParam || nonDateBasedProgramItems[selectedProgramDayNumber]?.exercises?.length;
    if (programType === 'free-form-program') {
      dispatch(saveNonDateBasedWorkoutExercise(
        currentUser,
        newProgramItemIndex,
        submissionObject,
        selectedProgramDayNumber,
        errorAddReset,
        {
          onSuccess: () => {
            setSubmitting(false);
            closeModal();
          },
          onError: () => {
            setSubmitting(false);
            closeModal();
          },
        },
      ));
    } else {
      dispatch(saveCalendarExercise(
        currentUser,
        newCalendarItemIndex,
        submissionObject,
        effectiveSelectedDate,
        errorAddReset,
        {
          onSuccess: () => {
            setSubmitting(false);
            closeModal();
          },
          onError: () => {
            setSubmitting(false);
            closeModal();
          },
        },
      ));
    }
  };

  return {
    handleAutoSaveCalendarItem,
  };
};

export default useCalendarAutoSaveCalendarItems;
